import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import { ValueToColor } from '@core/interfaces/bpc-display-config';
import { SelectOption } from '@shared/interfaces/config';

interface MainAndOtherOptions {
  placeholder: SelectOption;
  main: SelectOption[];
  other: SelectOption[];
}

@Component({
  name: 'bpc-countries-selector',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class CountriesSelector extends mixins(AbstractField) {
  @Prop([String, Number, Boolean]) readonly value: string | number | boolean;

  @Prop(Array) readonly options: SelectOption[];

  @Prop(Array) readonly valueToColor: ValueToColor[];

  @Prop([String, Number, Boolean]) readonly initialValue: string | number | boolean;

  get model(): string | number | boolean {
    return this.value;
  }
  set model(val: string | number | boolean) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  get selectClass(): string {
    const color = this.valueToColor?.find(item => item.value === this.model)?.color;
    return color ? `${color}` : '';
  }

  // get orderedOptions(): SelectOption[] {
  get orderedOptions(): MainAndOtherOptions {
    const nullOption = this.options.find(
      option => option.value === null || option.value === 'null',
    );
    const firstCountries = this.options.filter(option => {
      if (option.value !== null && option.value !== 'null') {
        const valueToCheck = option.value.toLowerCase();
        return valueToCheck === 'be' || valueToCheck === 'es' || valueToCheck === 'fr';
      } else {
        return false;
      }
    });

    const alphabetical = this.options
      .filter(option => {
        if (option.value !== null && option.value !== 'null') {
          const valueToCheck = option.value.toLowerCase();
          return valueToCheck !== 'be' && valueToCheck !== 'es' && valueToCheck !== 'fr';
        } else {
          return false;
        }
      })
      .sort((a, b) => {
        const translatedA: string = String(this.$t(a.text));
        const translatedB: string = String(this.$t(b.text));

        // normalize('NFD') ->  decomposes combined graphemes into the combination of simple ones.
        //                      è ends up expressed as e +  ̀.
        // [\u0300-\u036f] range takes all the accent strings

        if (
          translatedA.normalize('NFD').replace(/[\u0300-\u036f]/g, '') <
          translatedB.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        ) {
          return -1;
        }
        if (
          translatedA.normalize('NFD').replace(/[\u0300-\u036f]/g, '') >
          translatedB.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        ) {
          return 1;
        }
        return 0;
      });

    // return [nullOption].concat(firstCountries, alphabetical);
    return {
      placeholder: nullOption,
      main: firstCountries,
      other: alphabetical,
    };
  }

  onChange($event) {
    this.$emit('change', $event);
  }
}
